import { type Request } from 'express';
import { Generic } from './../internal/dictionary-service';
import { Recruiter, User } from './../internal/recruiter-service';

export enum DatabaseCode {
  MAIN = 'main',
  NOTIFICATION = 'notification',
  INTERNAL_NOTIFICATION = 'internal-notification',
  KERNEL_INTEGRATION = 'kernel-integration',
}

export type LocaleCode = 'en' | 'ru' | 'uk';

export enum ExternalResource {
  RobotaUa = 'robotaUa',
}

export interface RequestWithUser extends Request {
  user: User.RequestInfo;
  userDetails?: Recruiter.MyInfo;
}

export interface BooleanResponse {
  result: boolean;
}
export interface NumericResponse {
  result: number;
}

export type UnaryOperator<T, R> = (source: T) => R;

export interface IncludedItem extends Generic.Entity {
  count: number;
}
export interface ProfilesIncluded {
  authors: IncludedItem[];
  rejectReasons: IncludedItem[];
  statuses: IncludedItem[];
  sources: IncludedItem[];
}

export interface EntitiesList<T> {
  items: T[];
  included?: ProfilesIncluded;
  totalCount: number;
}
